import React from 'react';
import classNames from 'classnames';
import { List } from 'immutable';

import { Paragraph } from '@uncinc/react-drupal-core';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import { WysiwygField } from '../../../components';

const NodeParagraphsPage = ({ entity, className }) => {
  const classes = classNames(className, 'NodePage');
  return (
    <article typeof="schema:WebPage" className={classes} id="main">
      <Container>
        {entity.getIn(['body', 0, 'processed']) ? (
          <div className="row">
            <WysiwygField
              property="schema:text"
              className="node--page--body font-size--body--large subheading2 col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10"
              html={entity.getIn(['body', 0, 'processed'], '')}
            />
          </div>
        ) : null}
      </Container>

      {entity.get('field_paragraphs') ? (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
            return (
              <Paragraph
                key={`paragraph:${id}:${language}`}
                id={id}
                entity={paragraph.get('entity')}
              />
            );
          })}
        </div>
      ) : null}
    </article>
  );
};

export default NodeParagraphsPage;
